 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		71: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"1":"ActionChannel~ActionDetail~ActionList~ApplyCard~ArticleDetail~BenefitOld~CardManageDetail~ChannelLis~8dee63a8","2":"HljHosImg~HospitalDetail","3":"ActionChannel","4":"ActionDetail","5":"ActionList","6":"ApplyCard","7":"ArticleDetail","8":"BenefitOld","9":"BuyMedicine","10":"CardManageDetail","11":"CardManageList","12":"ChannelList","13":"DeptDetail","14":"DoctorDetail","15":"DoctorList","16":"DoctorSearch","17":"EpidemicIndex","18":"FeverClinic","19":"GetPhoto","20":"HealthAdvice","21":"HealthAdviceDetail","22":"HljArticle","23":"HljHosImg","24":"HljQRcode","25":"HospitalDetail","26":"HospitalList","27":"HospitalSearch","28":"Introduce","29":"JkljIndex","30":"JkljNewIndex","31":"MwapSkip","32":"NoticeDetail","33":"NoticeList","34":"OldChannel","35":"OldDetail","36":"OldList","37":"OnlineConsultation","38":"OnlineVisit","39":"PhoneConsultation","40":"PhoneList","41":"PortalSkip","42":"PreventServer","43":"QuestionDetail","44":"QuestionList","45":"QuestionSearch","46":"RecordDetatil","47":"RecordList","48":"RegisterBindCard","49":"RegisterBindCardContact","50":"RegisterBindCardDetail","51":"SearchItem","52":"Skip","53":"TextPrivate","54":"TextTreaty","55":"UploadPhoto","56":"UserAddPatient","57":"UserForgetGetCode","58":"UserForgetPassword","59":"UserIdCard","60":"UserIndex","61":"UserInformation","62":"UserLogin","63":"UserPassword","64":"UserPatientList","65":"UserPhone","66":"UserRegisterGetCode","67":"UserRegisterJudgePhone","68":"UserRegisterPassword","69":"UserSet","70":"YiMiao","72":"basicMes","73":"complaints","74":"content","75":"healthRecord","76":"hospital-list","77":"index","78":"login","79":"not-found","80":"partiesMes","81":"place","82":"textAgreement","83":"userCancel","84":"userCancelKnow","85":"userCancelWhy","86":"verfyCode"}[chunkId]||chunkId) + "-" + {"1":"081562","2":"cda82b","3":"0fd17d","4":"27cef5","5":"62dab5","6":"9a86ae","7":"7ea48c","8":"b1a13a","9":"db6fa7","10":"100671","11":"8d1df8","12":"71c590","13":"cd28ce","14":"c79423","15":"8592f8","16":"673ef8","17":"8e6abb","18":"356d84","19":"8a810c","20":"f6bfe2","21":"bd121f","22":"71717e","23":"5ded9c","24":"7a8310","25":"1a750b","26":"a17762","27":"b616ff","28":"d2983b","29":"2b1812","30":"a77dde","31":"fa58e3","32":"1468d8","33":"a391d2","34":"a47906","35":"dffda9","36":"2da94b","37":"e22444","38":"27d199","39":"a348e6","40":"c26cd4","41":"9d4503","42":"621200","43":"629512","44":"bb18e7","45":"3c5b11","46":"27e532","47":"3ca2f9","48":"0b6e5d","49":"d82aa6","50":"31f5bf","51":"2ad022","52":"a49182","53":"87217f","54":"21ebcc","55":"f2e15a","56":"795a38","57":"082f67","58":"50ed0b","59":"71f21c","60":"140f27","61":"4fa2bd","62":"1431fb","63":"b4e5aa","64":"dcb703","65":"950b1f","66":"1e5d33","67":"e94d11","68":"6d493d","69":"09f8b1","70":"ec4483","72":"21c1dc","73":"12f943","74":"a09c5b","75":"3a71b6","76":"e8775f","77":"c266d9","78":"7b519f","79":"f39eca","80":"edbbba","81":"299ac5","82":"949cfc","83":"7cc1d3","84":"1eaeb3","85":"b6990b","86":"133bb5","87":"92cf37","88":"83c5b0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([332,0]);
 	// run deferred modules when ready
 	return checkDeferredModules();
